import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';

const LazyImage = ({ className = [], ...props }) => {
	if (!Array.isArray(className)) className = [className];

	// All props should be returned from utils/image helper.
	return (
		<img className={[...className].join(' ')} {...props} />
	);
};

export default hot(module)(LazyImage);
